const ThemeManager = {
  initializeTheme() {
    const savedTheme = localStorage.getItem("snilinkTheme");
    if (savedTheme) {
      document.documentElement.classList.add(savedTheme);
    } else {
      localStorage.setItem("snilinkTheme", "dark");
    }
  },
  toggleTheme() {
    const currentTheme = document.documentElement.classList.contains("dark")
      ? "dark"
      : "light";
    const newTheme = currentTheme === "dark" ? "light" : "dark";
    document.documentElement.classList.remove(currentTheme);
    document.documentElement.classList.add(newTheme);
    localStorage.setItem("snilinkTheme", newTheme);
  },

  getTheme() {
    return document.documentElement.classList.contains("dark")
      ? "dark"
      : "light";
  },
};

export default ThemeManager;
